<div class="fdd-bottom-grid">
  <section class="fdd-card fdd-block5 fdd-block5--anomalies">
    <div class="fdd-block5__scroll">
      @if (anomaliesLoading) {
        <div class="fdd-block5__loader">
          <app-loading [loading]="true"></app-loading>
        </div>
      } @else if (anomaliesForSelectedDay.length) {
        @for (row of anomaliesForSelectedDay; track $index) {
          <app-field-details-anomaly-row [row]="row" (showOnMap)="showAnomalyOnMap.emit(row)" />
        }
      } @else {
        <div class="fdd-empty muted">{{ 'FIELD_DETAILS_V2.NO_ANOMALY_DAY' | translate }}</div>
      }
    </div>
  </section>

  <section class="fdd-card fdd-block6">
    <ng-template #recoTabTpl>
      <div class="fdd-reco-list" #recoListScroll>
        @for (item of recommendations; track item.codeFromEnum) {
          <div
            class="fdd-reco-row"
            [class.fdd-reco-row--focused]="item.codeFromEnum === focusedRecommendationCode"
            [attr.data-reco-code]="item.codeFromEnum"
            [style.borderLeftColor]="item.color"
          >
            @if (item.typeLabelKey) {
              <div class="fdd-reco-type">{{ item.typeLabelKey | translate }}</div>
            }
            @let recoText = item.recommendationSource | serverTranslate: 'recommendation';
            @if (recoText) {
              <div class="fdd-reco-text">{{ recoText }}</div>
            } @else {
              <div class="fdd-reco-text muted">{{ 'FIELD_DETAILS_V2.RECOMMENDATIONS_EMPTY' | translate }}</div>
            }
          </div>
        }
        @if (!recommendations.length) {
          <div class="fdd-tab-placeholder muted">{{ 'FIELD_DETAILS_V2.RECOMMENDATIONS_EMPTY' | translate }}</div>
        }
      </div>
    </ng-template>
    <ng-template #agroTabTpl>
      <div class="fdd-agro-list">
        @for (m of agroMeasures; track m.id || $index) {
          <div class="fdd-agro-row">
            <div class="fdd-agro-name">{{ m | serverTranslate: 'names' }}</div>
            @if (hasAgroWindow(m)) {
              <div class="fdd-agro-dates muted">{{ agroMeasureWindow(m) }}</div>
            }
          </div>
        }
        @if (!agroMeasures.length) {
          <div class="fdd-empty muted">—</div>
        }
      </div>
    </ng-template>
    @if (detailTabs.length) {
      <app-tabs
        [tabs]="detailTabs"
        [activeTab]="detailActiveTab"
        (tabChanged)="onDetailTabChange($event)"
      ></app-tabs>
    }
  </section>

  <section class="fdd-card fdd-block7">
    <div class="fdd-block7__head">
      <span class="fdd-card-title"><i class="pi pi-camera"></i> {{ 'FIELD_DETAILS_V2.FIELD_PHOTOS' | translate }}</span>
      @if (photosTotal > 3) {
        <button type="button" class="fdd-link" (click)="openPhotoSlider.emit(0)">
          {{ 'FIELD_DETAILS_V2.ALL_PHOTOS' | translate }} ({{ photosTotal }})
        </button>
      }
    </div>
    @if (fieldPhotosLoading) {
      <p-progressBar
        class="fdd-field-photos-progress"
        [value]="fieldPhotosProgress"
        [showValue]="true"
      ></p-progressBar>
    }
    <div class="fdd-photo-row">
      @for (p of photoStrip; track $index; let i = $index) {
        <button type="button" class="fdd-photo-thumb" (click)="openPhotoSlider.emit(i)">
          <img [src]="p.src" [alt]="p.name" />
        </button>
      }
      @if (!photoStrip.length) {
        <div class="fdd-empty muted">{{ 'FIELD_DETAILS_V2.NO_PHOTOS' | translate }}</div>
      }
      @if (photosTotal > 3) {
        <button type="button" class="fdd-photo-more" (click)="openPhotoSliderFromMore.emit()">+{{ photosTotal - 3 }}</button>
      }
    </div>
  </section>
</div>

@if (dataUpdatedDisplay) {
  <div class="fdd-card fdd-card--meta">
    <div class="fdd-updated muted">
      {{ 'FIELD_DETAILS_V2.DATA_UPDATED' | translate }}: {{ dataUpdatedDisplay | date: 'dd.MM.yyyy HH:mm' }}
    </div>
  </div>
}
